module.exports = __webpack_public_path__ + "static/media/stripe-create-account_9.5c8fb503.png";